<template>
  <div class="max-w-lg mx-auto lg:max-w-7xl px-8 xl:px-4 pt-8 pb-4">
    <div class="mt-2 md:flex md:items-center md:justify-between">
      <div>
        <!-- <div class="sm:hidden">
          <label for="tabs" class="sr-only">Select a tab</label>
          <select
            id="tabs"
            name="tabs"
            class="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
          >
            <option>
              <router-link :to="{ name: 'courses' }">Все</router-link>
            </option>
            <option>
              <router-link :to="{ name: 'courses_inprogress' }"
                >В процессе</router-link
              >
            </option>
            <option>
              <router-link :to="{ name: 'courses_done' }"
                >Завершённые</router-link
              >
            </option>
          </select>
        </div> -->

        <!-- hidden sm:block -->
        <div class="block">
          <div class="border-b border-gray-200">
            <nav class="-mb-px flex space-x-8" aria-label="Tabs">
              <!-- Current: "border-indigo-500 text-indigo-600", Default: "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300" -->

              <router-link
                :to="{ name: 'courses' }"
                :class="[
                  'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm',
                  index == 1
                    ? 'border-indigo-500 text-indigo-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                ]"
                >Все</router-link
              >

              <router-link
                :to="{ name: 'courses_inprogress' }"
                :class="[
                  'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm',
                  index == 2
                    ? 'border-indigo-500 text-indigo-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                ]"
                >В процессе</router-link
              >
              <router-link
                :to="{ name: 'courses_done' }"
                :class="[
                  'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm',
                  index == 3
                    ? 'border-indigo-500 text-indigo-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                ]"
                >Завершённые</router-link
              >
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["index"],
};
</script>
<style scoped>
/*
    .highlighted {
        background-color: pink;
    }
*/
</style>
